const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimizeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "12b6b7dc44"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fcfcfc",
      fillOpacity: 1
    },
    d: "M 37.5 0 C 16.820312 0 0 16.820312 0 37.5 C 0 58.179688 16.820312 75 37.5 75 C 58.179688 75 75 58.179688 75 37.5 C 75 16.820312 58.179688 0 37.5 0 Z M 37.5 5 C 55.480469 5 70 19.519531 70 37.5 C 70 55.480469 55.480469 70 37.5 70 C 19.519531 70 5 55.480469 5 37.5 C 5 19.519531 19.519531 5 37.5 5 Z M 37.5 5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fcfcfc",
      fillOpacity: 1
    },
    d: "M 20.007812 35 C 19.679688 35 19.359375 35.0625 19.054688 35.191406 C 18.746094 35.316406 18.476562 35.496094 18.242188 35.730469 C 18.007812 35.964844 17.828125 36.238281 17.699219 36.542969 C 17.574219 36.847656 17.507812 37.167969 17.507812 37.5 C 17.507812 37.832031 17.574219 38.152344 17.699219 38.457031 C 17.828125 38.761719 18.007812 39.035156 18.242188 39.269531 C 18.476562 39.503906 18.746094 39.683594 19.054688 39.808594 C 19.359375 39.9375 19.679688 40 20.007812 40 L 54.988281 40 C 55.320312 40 55.640625 39.9375 55.945312 39.808594 C 56.253906 39.683594 56.523438 39.503906 56.757812 39.269531 C 56.992188 39.035156 57.171875 38.761719 57.300781 38.457031 C 57.425781 38.152344 57.488281 37.832031 57.488281 37.5 C 57.488281 37.167969 57.425781 36.847656 57.300781 36.542969 C 57.171875 36.238281 56.992188 35.964844 56.757812 35.730469 C 56.523438 35.496094 56.253906 35.316406 55.945312 35.191406 C 55.640625 35.0625 55.320312 35 54.988281 35 Z M 20.007812 35 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeWhite);
export default __webpack_public_path__ + "static/media/minimize-white.628062bd6362cde5a4d6948df468dae4.svg";
export { ForwardRef as ReactComponent };